module.exports = __webpack_public_path__ + "img/PhantomJS.76762e97.png";